/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Tut_Forms_TipInputs */

const en_pc_tut_forms_tip = /** @type {(inputs: Pc_Tut_Forms_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dynamic XFA forms, common in some government PDFs, are not fully supported yet.`)
};

const zh_pc_tut_forms_tip = /** @type {(inputs: Pc_Tut_Forms_TipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`动态 XFA 表单（常见于部分政府文件）暂未完全支持。`)
};

/**
* | output |
* | --- |
* | "Dynamic XFA forms, common in some government PDFs, are not fully supported yet." |
*
* @param {Pc_Tut_Forms_TipInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_tut_forms_tip = /** @type {((inputs?: Pc_Tut_Forms_TipInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Tut_Forms_TipInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_tut_forms_tip(inputs)
	return zh_pc_tut_forms_tip(inputs)
});
export { pc_tut_forms_tip as "pc.tut.forms.tip" }